import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./dialog.component.html?ngResource";
import { Component } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
let DialogComponent = class DialogComponent {
    ngxSmartModalService;
    constructor(ngxSmartModalService) {
        this.ngxSmartModalService = ngxSmartModalService;
    }
    static ctorParameters = () => [
        { type: NgxSmartModalService }
    ];
};
DialogComponent = __decorate([
    Component({
        selector: 'app-dialog',
        template: __NG_CLI_RESOURCE__0,
    })
], DialogComponent);
export { DialogComponent };
